export default {
    routeBusinessStockDeliveryInformView: {
        Basic: '出库基本信息',
        Delivery: '出库通知单号',
        Outbound: '出库逻辑仓编码',
        Name: '出库逻辑仓名称',
        Issue: '出库类型',
        status: '出库状态',
        Buyer: '买家备注',
        Merchant: '商家备注',
        Logistics: '物流',
        business: '物流业务',
        Consignee: '收货人',
        Contact: '联系电话',
        Shipping: '收货地址',
        Creation: '创建时间',
        Created: '创建人',
        Associated: '关联单据',
        Pre: '前置单号',
        Internal: '内部订单号',
        Third: '客户订单号',
        result: '出库结果单号',
        View: '查看更多',
        Product: '商品明细',
        // code: '商品编码',
        SKU: 'SKU名称',
        SKUcode: 'SKU编码',
        Shipment: '发货数量',
        Quantity: '已发货数量',
        // Productname: '商品名称',
        Total: '发货总数量：',
        shipped: '已发货数量：',
        go: '历史关联重发单',
    }
};
